module.exports = __webpack_public_path__ + "img/gwater-licence.ac2a52c8.svg";